import Radium from "radium";
import { connect } from "react-redux";

import { loginWithPassword } from "../user.actions";
import Login, { ILoginActions } from "./login";
import { navigateTo } from "../../home";

export default connect(
  null,
  (dispatch): ILoginActions => ({
    login: (username, password) =>
      dispatch(loginWithPassword(username, password)),
    routeToResetPassword: () => dispatch(navigateTo("/resetPassword"))
  })
)(Radium(Login));
